import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { DisplayService } from '../../services/display.service';
import { LeaderboardService, LeaderboardEntry } from '../../services/leaderboard.service';

@Component({
  selector: 'app-leaderboard',
  standalone: true,
  imports: [IonicModule, CommonModule, RouterModule, TranslateModule],
  templateUrl: './leaderboard.page.html',
  styleUrls: ['./leaderboard.page.scss'],
})
export class LeaderboardPage implements OnInit, OnDestroy {
  entries: LeaderboardEntry[] = [];
  loading = false;
  darkMode = false;
  private userSub!: Subscription;
  private currentUser: any = null;

  constructor(
    private authService: AuthService,
    private displayService: DisplayService,
    private leaderboardService: LeaderboardService
  ) {}

  ngOnInit() {
    this.userSub = this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
      this.darkMode = user?.darkMode ?? false;
    });
    this.loadLeaderboard();
  }

  ngOnDestroy() {
    this.userSub?.unsubscribe();
  }

  async loadLeaderboard(event?: any) {
    this.loading = !event;
    try {
      this.entries = await this.leaderboardService.getLeaderboard();
    } catch (e) {
      console.error('Failed to load leaderboard:', e);
    } finally {
      this.loading = false;
      if (event) event.target.complete();
    }
  }

  doRefresh(event: any) {
    this.loadLeaderboard(event);
  }

  toggleTheme() {
    this.darkMode = !this.darkMode;
    this.displayService.setDarkMode(this.darkMode);
  }

  rankLabel(rank: number): string {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return `#${rank}`;
  }
}
